// @view/panels/payment/PaymentSetup.panel.tsx
import React from "react";

export type PaymentSetupPhase = "square" | "stripe" | "missingSecret";

type PaymentSetupPanelProps = {
    phase: PaymentSetupPhase;
    squareView: React.ReactElement;
    stripeView: React.ReactElement;
    missingSecretView: React.ReactElement;
};

const PaymentSetupPanel: React.FC<PaymentSetupPanelProps> = ({
    phase,
    squareView,
    stripeView,
    missingSecretView,
}) => {
    const render = {
        square: squareView,
        stripe: stripeView,
        missingSecret: missingSecretView,
    } as const satisfies Record<PaymentSetupPhase, React.ReactElement>;

    return (
        <div
            data-testid="page-paymentSetup"
            data-page-state="ready"
            data-page-phase={phase}
        >
            {render[phase]}
        </div>
    );
};

export default PaymentSetupPanel;
